module.exports = __webpack_public_path__ + "img/56.8cfe9dd0.png";